/*eslint-disable*/
import React from "react";
import './footer.scss'

import Logo from '../../../assets/img/logo/Footer-Logo.jpg';
import {NavLink, Link} from "react-router-dom";
import {Icon} from "@iconify/react";
import webConfig from "../../../config/WebConfig";
import {NavItem} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import * as constants from '../../../const/constants';


class CardsFooter extends React.Component {

    reRouteWithId = (place) => {
        window.location.href = constants.BASE_ROUTE + place
    };

    render() {
        return (
            <React.Fragment>
                <footer className="footer-area pb-4 ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-12">
                                <div className="single-footer">
                                    <h4 className="logo">
                                        <a href="#home">
                                            <img style={{maxWidth: "30%"}} src={Logo} alt="log"/>
                                        </a>
                                    </h4>
                                    <p className='mt-2'>{webConfig.FooterDesc}</p>


                                    <div className=' social-media d-flex justify-content-start pt-2'>
                                        <a target={"_blank"}
                                           href={'https://www.facebook.com/CJ.chandikajayamaha?mibextid=ZbWKwL'}>
                                            <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'
                                                  color='#ADAFBF' height='30px' icon="bxl:facebook"/>
                                        </a>
                                        <a target={"_blank"}
                                           href={'https://youtube.com/@cjcombinedmathsofficial?si=6X5PHWFZIJj8joFh'}>
                                            <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'
                                                  color='#ADAFBF' height='30px'
                                                  icon="akar-icons:youtube-fill"/>
                                        </a>
                                        <a target={"_blank"} href={'https://api.whatsapp.com/send?phone=94707683711'}>
                                            <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'
                                                  color='#ADAFBF' height='30px'
                                                  icon="akar-icons:whatsapp-fill"/>
                                        </a>

                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-1 col-md-0"></div>
                            <div className="col-lg-2 col-md-4">
                                <div className="single-footer footer-navbar-nav">
                                    <h3>Services</h3>
                                    <div className='d-flex flex-column'>


                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to='#teachersSection'
                                            // className={`nav-event-btn`}
                                            onClick={() => this.reRouteWithId('#teachersSection')}
                                        >
                                            Teachers
                                        </NavLink>


                                        {/* <li>
                                            {this.props.pageName === "home" ? (
                                                <a href="#pricing">
                                                    <i className="icofont-double-right" />
                                                    Pricing
                                                </a>
                                            ) : (
                                                <NavLink
                                                    to="/"
                                                    activeClassName=""
                                                >
                                                    <i className="icofont-double-right" />
                                                    pricing
                                                </NavLink>
                                            )}
                                        </li> */}

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-4">
                                <div className="single-footer">
                                    <h3>Institute</h3>
                                    <div className='d-flex flex-column'>
                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to="/"
                                            activeClassName="">
                                            24A/1/1, Old Kesbewa Road, Gangodawila, Nugegoda.
                                        </NavLink>

                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to="/"
                                            activeClassName="">
                                            0772383711,0707683711
                                        </NavLink>

                                        {/*<NavLink*/}
                                        {/*    className="py-2" style={{color: '#ADAFBF'}}*/}
                                        {/*    to="/"*/}
                                        {/*    activeClassName="">*/}
                                        {/*    Email*/}
                                        {/*</NavLink>*/}
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-2 col-md-4">
                                <div className="single-footer">
                                    {/*<h3>Help</h3>*/}
                                    <div className='d-flex flex-column footer-items-center'>
                                        <a
                                            className={`nav-event-btn`}
                                            // onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}
                                            href={constants.BASE_ROUTE + constants.HOME_HELP_ROUTE}
                                        >
                                            Help
                                        </a>
                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to='#FAQ'
                                            className={`nav-event-btn`}
                                            onClick={() => this.reRouteWithId('#FAQ')}
                                        >
                                            FAQ
                                        </NavLink>
                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to='#inquiryForm'
                                            className={`nav-event-btn`}
                                            onClick={() => this.reRouteWithId('#inquiryForm')}
                                        >
                                            Contact Us
                                        </NavLink>

                                    </div>
                                </div>
                            </div>

                            <p className="copyright-text">
                                © {new Date().getFullYear()} All rights reserved | Powered by Edulab
                            </p>

                        </div>
                    </div>

                </footer>
            </React.Fragment>
        );
    }
}

export default CardsFooter;
